import { useEffect } from "react";

const useEscapeKey = (callback: () => void, enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        callback();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [callback, enabled]);
};

export default useEscapeKey;
